import { render, staticRenderFns } from "./PopupSetDocsStatus.vue?vue&type=template&id=2539ae23"
import script from "./PopupSetDocsStatus.vue?vue&type=script&lang=ts"
export * from "./PopupSetDocsStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports